import { UntypedFormGroup } from '@angular/forms';

import { FormlyFieldConfig } from '@ngx-formly/core';
import { Selector } from '@ngxs/store';

import { DatasheetGroup } from '../../models/datasheet.model';
import { DatasheetFormlyUtils } from '../../utils/datasheet-formly.utils';
import { DatasheetState, DatasheetStateModel } from './datasheet.state';

export class DatasheetSelectors {
  @Selector([DatasheetState])
  static getDatasheet(state: DatasheetStateModel) {
    return state.groups;
  }

  @Selector([DatasheetState])
  static getMessages(state: DatasheetStateModel) {
    return state.messages;
  }

  @Selector([DatasheetState])
  static getEditedValues(state: DatasheetStateModel) {
    return state.editedValues;
  }

  @Selector([DatasheetSelectors.getDatasheet])
  static getSectionTables(groups: DatasheetGroup[]): FormlyFieldConfig[] {
    return DatasheetFormlyUtils.getSectionTables(groups);
  }

  @Selector([DatasheetState])
  static getSelectedGroup(state: DatasheetStateModel) {
    return state.groupId;
  }

  @Selector([DatasheetState])
  static getSelectedSection(state: DatasheetStateModel) {
    return state.sectionId;
  }

  @Selector([DatasheetState])
  static getSelectedRow(state: DatasheetStateModel) {
    return state.rowKey;
  }

  @Selector([DatasheetState])
  static getForm(state: DatasheetStateModel) {
    return state.form;
  }

  @Selector([DatasheetState])
  static getIsEditing(state: DatasheetStateModel) {
    return state.isEditing;
  }

  @Selector([DatasheetState])
  static getSomethingEdited(state: DatasheetStateModel) {
    return Object.entries(state.editedValues).length > 0;
  }
}
